import React from 'react';

// Word-level LCS diff. Returns ops: {type: 'same'|'del'|'add', text}
export function wordDiff(aText, bText) {
  const a = (aText || '').split(/\s+/).filter(Boolean);
  const b = (bText || '').split(/\s+/).filter(Boolean);
  if (a.length * b.length > 600000) {
    return a.join(' ') === b.join(' ')
      ? [{ type: 'same', text: a.join(' ') }]
      : [{ type: 'del', text: aText }, { type: 'add', text: bText }];
  }
  const m = a.length, n = b.length;
  const dp = Array.from({ length: m + 1 }, () => new Uint16Array(n + 1));
  for (let i = m - 1; i >= 0; i -= 1) {
    for (let j = n - 1; j >= 0; j -= 1) {
      dp[i][j] = a[i] === b[j] ? dp[i + 1][j + 1] + 1 : Math.max(dp[i + 1][j], dp[i][j + 1]);
    }
  }
  const ops = [];
  const push = (type, word) => {
    const last = ops[ops.length - 1];
    if (last && last.type === type) last.text += ` ${word}`;
    else ops.push({ type, text: word });
  };
  let i = 0, j = 0;
  while (i < m && j < n) {
    if (a[i] === b[j]) { push('same', a[i]); i += 1; j += 1; }
    else if (dp[i + 1][j] >= dp[i][j + 1]) { push('del', a[i]); i += 1; }
    else { push('add', b[j]); j += 1; }
  }
  while (i < m) { push('del', a[i]); i += 1; }
  while (j < n) { push('add', b[j]); j += 1; }
  return ops;
}

const styleFor = (type, side) => {
  if (type === 'same') return 'text-slate-600';
  if (type === 'del') return side === 'old' ? 'bg-rose-100 text-rose-800 rounded px-0.5 line-through decoration-rose-400' : 'hidden';
  return side === 'new' ? 'bg-emerald-100 text-emerald-800 rounded px-0.5' : 'hidden';
};

export const DiffView = ({ oldText, newText, oldLabel, newLabel }) => {
  const ops = wordDiff(oldText, newText);
  const changed = ops.some(o => o.type !== 'same');
  return (
    <div data-testid="rfp-diff-view">
      {!changed && <p className="text-[10px] text-slate-400 mb-1.5">No wording differences between these versions.</p>}
      <div className="grid grid-cols-2 gap-2">
        {['old', 'new'].map(side => (
          <div key={side} className="border border-slate-200 rounded-md overflow-hidden">
            <p className={`text-[9px] font-bold uppercase tracking-wide px-2 py-1 ${side === 'old' ? 'bg-rose-50 text-rose-700' : 'bg-emerald-50 text-emerald-700'}`}>
              {side === 'old' ? oldLabel : newLabel}
            </p>
            <p className="text-[11px] leading-relaxed p-2 max-h-64 overflow-y-auto whitespace-pre-wrap"
              data-testid={`rfp-diff-${side}`}>
              {ops.map((o, k) => (
                <span key={k} className={styleFor(o.type, side)}>{o.text}{' '}</span>
              ))}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
};
